export default "__VITE_ASSET__Ba5oQ86w__"